(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow_with_video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('slideshow-video-controller')) {
  customElements.define('slideshow-video-controller', class extends HTMLElement {
    constructor() {
      super();
      this.editorSlide = null;
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.slideshow__slide');
        if (!slide || !this.contains(slide)) return;
        this.editorSlide = slide;
        if (!this.events || this.events.signal.aborted) return;
        this.records.forEach((record) => { record.manual = false; });
        this.slideshow.pause?.();
        this.sync();
      });
      this.addEventListener('shopify:block:deselect', (event) => {
        if (event.target.closest('.slideshow__slide') !== this.editorSlide) return;
        this.editorSlide = null;
        if (this.events && !this.events.signal.aborted) this.sync();
      });
    }

    connectedCallback() {
      this.connectFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.events) return;
      this.slideshow = this.querySelector('slideshow-component');
      this.slider = this.slideshow?.querySelector('[id^="Slider-"]');
      if (!this.slider) return;

      this.events = new AbortController();
      const signal = this.events.signal;
      this.slides = Array.from(this.slider.querySelectorAll('.slideshow__slide'));
      this.activeSlide = this.findActiveSlide();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayButton = this.slideshow.querySelector('.slideshow__autoplay');
      this.slideshowPaused = this.autoplayButton?.classList.contains('slideshow__autoplay--paused') || false;
      if (this.editorSlide && !this.contains(this.editorSlide)) this.editorSlide = null;

      this.records = Array.from(this.slider.querySelectorAll('.video-slideshow__video')).map((video) => {
        const slide = video.closest('.slideshow__slide');
        const record = {
          video,
          slide,
          media: video.closest('.banner__media'),
          button: slide.querySelector('[data-video-toggle]'),
          autoplay: slide.dataset.videoAutoplay === 'true',
          visible: !('IntersectionObserver' in window),
          userPaused: false,
          manual: false,
          blocked: false,
          finished: false,
          pending: false,
          token: 0
        };
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.tabIndex = -1;
        record.button.hidden = false;
        record.button.addEventListener('click', () => this.toggleVideo(record), { signal });
        ['play', 'playing', 'pause'].forEach((eventName) => {
          video.addEventListener(eventName, () => this.paintButton(record), { signal });
        });
        video.addEventListener('ended', () => {
          record.finished = true;
          record.pending = false;
          this.paintButton(record);
        }, { signal });
        video.addEventListener('error', () => {
          record.blocked = true;
          record.pending = false;
          record.token += 1;
          this.paintButton(record);
        }, { signal });
        return record;
      });

      this.slideshow.addEventListener('slideChanged', (event) => {
        const slide = event.detail?.currentElement;
        if (this.slides.includes(slide)) this.setActiveSlide(slide);
      }, { signal });

      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) {
          this.records.forEach((record) => { record.manual = false; });
          this.respectReducedMotion();
        }
        this.sync();
      }, { signal });

      if (this.autoplayButton) {
        this.autoplayObserver = new MutationObserver(() => {
          const paused = this.autoplayButton.classList.contains('slideshow__autoplay--paused');
          if (paused && !this.slideshowPaused) {
            this.records.forEach((record) => { record.manual = false; });
          }
          this.slideshowPaused = paused;
          this.sync();
        });
        this.autoplayObserver.observe(this.autoplayButton, { attributes: true, attributeFilter: ['class'] });
      }

      if ('IntersectionObserver' in window) {
        const recordsByMedia = new Map(this.records.map((record) => [record.media, record]));
        this.visibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const record = recordsByMedia.get(entry.target);
            if (record) record.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          });
          this.sync();
        }, { threshold: [0, 0.15] });
        this.records.forEach((record) => this.visibilityObserver.observe(record.media));
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (!signal.aborted) this.setActiveSlide(this.findActiveSlide());
          });
        });
        this.resizeObserver.observe(this.slider);
      }

      customElements.whenDefined('slideshow-component').then(() => {
        if (signal.aborted || !this.isConnected) return;
        ['mouseover', 'mouseleave', 'focusin', 'focusout', 'click'].forEach((eventName) => {
          this.slideshow.addEventListener(eventName, () => {
            if (this.editorSlide) this.slideshow.pause?.();
          }, { signal });
        });
        this.respectReducedMotion();
        if (this.editorSlide) this.slideshow.pause?.();
        if (this.resumeRotation && !this.editorSlide && !this.motion.matches && this.slideshow.autoplayButtonIsSetToPlay) {
          this.slideshow.play?.();
        }
        this.resumeRotation = false;
        this.setActiveSlide(this.findActiveSlide());
      });
      this.sync();
    }

    findActiveSlide() {
      if (!this.slides?.length) return null;
      const viewport = this.slider.getBoundingClientRect();
      const center = viewport.left + viewport.width / 2;
      let distance = Infinity;
      let active = this.slides[0];
      this.slides.forEach((slide) => {
        const bounds = slide.getBoundingClientRect();
        const candidate = Math.abs(bounds.left + bounds.width / 2 - center);
        if (candidate < distance) {
          distance = candidate;
          active = slide;
        }
      });
      return active;
    }

    setActiveSlide(slide) {
      if (!slide) return;
      if (slide !== this.activeSlide) {
        this.records.forEach((record) => {
          if (record.slide !== this.activeSlide) return;
          this.stopVideo(record);
          record.manual = false;
          record.blocked = false;
          record.finished = false;
          if (record.video.readyState > 0) record.video.currentTime = 0;
        });
        this.activeSlide = slide;
      }
      this.sync();
    }

    respectReducedMotion() {
      if (this.motion.matches && this.autoplayButton && this.slideshow.autoplayButtonIsSetToPlay === true) {
        this.slideshow.autoPlayToggle?.();
      }
    }

    shouldPlay(record) {
      if (!this.isConnected || document.hidden || record.slide !== this.activeSlide || !record.visible) return false;
      if (record.userPaused || record.blocked || record.finished) return false;
      return record.manual || (record.autoplay && !this.slideshowPaused && !this.motion.matches && !this.editorSlide);
    }

    sync() {
      this.records.forEach((record) => {
        record.button.tabIndex = record.slide === this.activeSlide ? 0 : -1;
        record.button.setAttribute('aria-hidden', record.slide === this.activeSlide ? 'false' : 'true');
        if (this.shouldPlay(record)) {
          if (record.video.paused && !record.pending) this.startVideo(record);
        } else {
          this.stopVideo(record);
        }
        this.paintButton(record);
      });
    }

    startVideo(record) {
      record.pending = true;
      const token = ++record.token;
      this.paintButton(record);
      let result;
      try {
        result = record.video.play();
      } catch (error) {
        this.playFailed(record, token, error);
        return;
      }
      Promise.resolve(result).then(() => {
        if (token !== record.token) {
          if (!this.shouldPlay(record)) record.video.pause();
          return;
        }
        record.pending = false;
        if (!this.shouldPlay(record)) record.video.pause();
        this.paintButton(record);
      }).catch((error) => this.playFailed(record, token, error));
    }

    playFailed(record, token, error) {
      if (token !== record.token) return;
      record.pending = false;
      if (error?.name !== 'AbortError') record.blocked = true;
      this.paintButton(record);
    }

    stopVideo(record) {
      if (record.pending || !record.video.paused) {
        record.token += 1;
        record.pending = false;
        record.video.pause();
      }
    }

    toggleVideo(record) {
      if (record.pending || (!record.video.paused && !record.video.ended)) {
        record.userPaused = true;
        record.manual = false;
        this.stopVideo(record);
      } else {
        record.userPaused = false;
        record.manual = true;
        record.blocked = false;
        record.finished = false;
        if (record.video.error) record.video.load();
        if (record.video.ended && record.video.readyState > 0) record.video.currentTime = 0;
      }
      this.sync();
    }

    paintButton(record) {
      const playing = record.pending || (!record.video.paused && !record.video.ended);
      const label = playing ? record.button.dataset.pauseLabel : record.button.dataset.playLabel;
      record.button.dataset.playing = String(playing);
      record.button.setAttribute('aria-label', label);
      record.button.setAttribute('title', label);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.connectFrame);
      cancelAnimationFrame(this.resizeFrame);
      this.events?.abort();
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.autoplayObserver?.disconnect();
      this.records?.forEach((record) => {
        this.stopVideo(record);
        record.button.hidden = true;
        record.video.controls = true;
      });
      this.resumeRotation = this.slider?.getAttribute('aria-live') === 'off';
      this.slideshow?.pause?.();
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
